import { BaseProxy } from '@/proxies/BaseProxy'

export class CreateThreadProxy extends BaseProxy {
  constructor ({ parameters = {} } = {}) {
    super({
      endpoint: `createThread`,
      parameters,
    })
  }
}
